import React, { useMemo, useCallback } from 'react';
import { useSelector } from "react-redux";
import { getResolutionName } from '../../../containers/WorkkardDetail/utils';
import Icon from "../../../icons";
import { formatTimestamp, getUniqueTagsWithSystemFlag, PriorityFlag, renderModuleType } from "../util";
import { isMobile } from '../../../common/util';

const DiaryCell = ({ data, onItemClick }) => {
    const selectedDiary = useSelector(state => state.diaries.listing.selectedDiary);

    const isSelected   = selectedDiary === data.todo_id;
    const isActiveCard = isSelected || isMobile();
    const statusKey    = data?.status?.toLowerCase();
    
    const handleClick = useCallback(() => {
        if (!isSelected) onItemClick(data.todo_id);
    }, [isSelected, onItemClick, data.todo_id]);

    // Tags/Systemtags handler
    const uniqueTags = getUniqueTagsWithSystemFlag(data.tags, data.system_tags);
    
    return (
        <li
            className={`card ${isActiveCard ? 'active' : 'cardDisable'}`}
            onClick={handleClick}
        >
            <div className="rowSpaceBetween flexGrow colFlex">
                <div className="rowFlex flexAuto alignMiddle rowSpaceBetween">
                    <div className="diaryWkTitle rowFlex alignMiddle diaryTagStatus tagDiaryGroup flexGrow">
                        {renderModuleType(data, false)}
                        <span className="userTitle" title={data.title}>{data.title}</span>
                        <PriorityFlag
                            priority={data.priority_title}
                            isCompleted={data.completed}
                            status={data?.status}
                        />

                        <div className="rowFlex h__24 ml">
                            <dl>
                                <dd className={`status ${getResolutionName(statusKey, true)}`}>
                                    {getResolutionName(statusKey)}
                                </dd>
                            </dl>
                            <div className="dropDown animated noteAction superFaste">
                                <span className="icon"><Icon className="icon more" /></span>
                            </div>
                        </div>
                    </div>

                    <div className="alignRight">
                        <span className={isActiveCard ? 'diaryTime alignMiddle' : 'alignMiddle'}>
                            <Icon name="clock" className="icon" />
                            {data.due_on ? "Due Today. " : ""}
                            {formatTimestamp(data?.due_date, data?.due_date_tz, "time")}
                        </span>
                    </div>
                </div>
                <div className="diaryStatusTags mt">
                    {
                        uniqueTags.map(({ tag, isSystemTag }) => (
                            <label key={tag} className={`mr status tags ${isSystemTag ? "ReactTags__tag" : ""}`}>{tag}</label>
                        ))
                    }
                </div>
            </div>
        </li>
    );
};

export default DiaryCell;